import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import ProductPage from "@/pages/ProductPage";
import ApplicationsPage from "@/pages/ApplicationsPage";
import WhyDustMattersPage from "@/pages/WhyDustMattersPage";
import TechnologyPage from "@/pages/TechnologyPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import InvestorPortalPage from "@/pages/InvestorPortalPage";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTopHelper() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="min-h-screen bg-[#0a0b0d]">
      <div className="noise-overlay" />
      <BrowserRouter>
        <ScrollToTopHelper />
        <Navbar />
        <Routes>
          <Route path="/" element={<><HomePage /><Footer /></>} />
          <Route path="/product" element={<><ProductPage /><Footer /></>} />
          <Route path="/applications" element={<><ApplicationsPage /><Footer /></>} />
          <Route path="/why-dust-matters" element={<><WhyDustMattersPage /><Footer /></>} />
          <Route path="/technology" element={<><TechnologyPage /><Footer /></>} />
          <Route path="/contact" element={<><ContactPage /><Footer /></>} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/investors" element={<InvestorPortalPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
